module.exports = __webpack_public_path__ + "welcome1-2dc1281c8fa3503e72f5d4dd5d26e420.png";